import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/zacharyssmith" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/zach-smith/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>A portfolio designed and built by Zach Smith using the <a href="https://github.com/yujisatojr/react-portfolio-template" target="_blank" rel="noreferrer">portfolio template</a></p>
    </footer>
  );
}

export default Footer;